/**
 * Configuration constants for transcript module
 */

export const LECTURE_ID_REGEX = /\d{4}[A-ZА-ЯА-Я]\d{2}(?:[-A-ZА-Я\d]*)?/;

